//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import storeUtils from '~/utils/storeUtils';

export default {
  props: {
    type: { type: [String, Number], default: '' },
    command: { type: Object, default: () => ({}) },
    pages: { type: Number, default: 25 },
    disabled: { type: Boolean, default: false },
  },

  computed: {
    isP2Pay() {
      return process.env.VUE_APP_EXCLUDE_FEATURE?.split(' ').includes('transactions-old');
    },
  },

  methods: {
    ...mapActions('common', [
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
      'confirmAction',
    ]),
    ...mapActions('reports', {
      createReportAction: 'createReport',
    }),

    async createReport() {
      const { type, command, pages } = this;
      this.setGeneralProgress(true);
      try {
        const preLimit = command.limit || 100;
        const limit = pages > 0 ? Number(pages * preLimit) : 10000;

        const defaultData = {
          limit,
          offset: this.isP2Pay ? '0' : 0,
        };

        const payload = this.isP2Pay
          ? { type, request: { ...storeUtils.clearEmptyParams(command), limit } }
          : { type, data: { ...defaultData, ...command, limit } };

        await this.createReportAction(payload, pages);
        this.confirmAction({
          title: this.$t('common.Request created'),
          text: this.$t('common.Request for report has been created'),
          hasCancelButton: false,
        });
      } catch (error) {
        this.setErrorNotification(error.message);
      }
      this.setGeneralProgress(false);
    },
  },
};
